import { useEffect, useMemo, useState } from "react";
import { api, API_BASE } from "./api";

export const fallbackWebsiteContent = {
  settings: {
    brandName: "RP Infotech",
    tagline: "LED Displays & Digital Signage Solutions",
    logo: "/logo.png",
    phone: "+91 93230 37254",
    whatsapp: "919323037254",
    email: "info@rpsignage.com",
    address: "Vasai, Maharashtra, India",
    footer: "Digital Signage Software, LED TV, LED Active Displays, LED Interactive Panels, LED Floor Stands and Wall Mounted Displays by RP Infotech.",
  },
  home: {
    heroTitle: "LED Displays & Digital Signage Solutions for Every Business",
    heroSubtitle: "Commercial LED TVs, LED active display video walls, LED interactive panels for classrooms, floor stand and wall mounted LED displays, all managed through the RP Signage cloud platform.",
    heroImage: "/rp-signage-hero-banner.png",
    primaryCta: "Book Live Demo",
    secondaryCta: "View Products",
    thirdCta: "Contact Sales",
    stats: [
      { value: "10+", label: "Years Experience" },
      { value: "1000+", label: "Happy Clients" },
      { value: "5000+", label: "Installations" },
      { value: "24/7", label: "Support" },
    ],
  },
  products: [],
  solutions: [],
  industries: [],
  blogs: [],
  testimonials: [],
  faqs: [],
  downloads: [],
};

export function resolveWebsiteImage(path) {
  const value = String(path || "").trim();
  if (!value) return "/rp-signage-hero-banner.png";
  if (/^https?:\/\//i.test(value) || value.startsWith("data:") || value.startsWith("blob:")) {
    return value;
  }

  const normalized = value.startsWith("/") ? value : `/${value}`;
  const backendMediaPaths = ["/uploads/", "/media/", "/files/"];
  if (backendMediaPaths.some((prefix) => normalized.startsWith(prefix))) {
    const root = API_BASE.replace(/\/api$/, "");
    return `${root}${normalized}`;
  }

  return normalized;
}

export function whatsappUrl(settings = {}, text = "Hello RP Infotech, I want to know more about RP Signage.") {
  const number = String(settings.whatsapp || settings.phone || "919323037254").replace(/\D/g, "");
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}

export function publicItems(rows = []) {
  return [...(rows || [])]
    .filter((row) => row && row.active !== false)
    .sort((a, b) => Number(a.sort || 99) - Number(b.sort || 99));
}

export function findBySlug(rows = [], slug = "") {
  return publicItems(rows).find((row) => String(row.slug || "") === String(slug || ""));
}

export function useWebsiteContent() {
  const [data, setData] = useState(fallbackWebsiteContent);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api.get("/public/website")
      .then(({ data: response }) => {
        if (mounted) setData({ ...fallbackWebsiteContent, ...(response || {}) });
      })
      .catch(() => {
        if (mounted) setData(fallbackWebsiteContent);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return useMemo(() => ({ data, loading }), [data, loading]);
}
